import { render, staticRenderFns } from "./headerSercSetting.vue?vue&type=template&id=8fccccba&scoped=true&"
import script from "./headerSercSetting.vue?vue&type=script&lang=js&"
export * from "./headerSercSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fccccba",
  null
  
)

export default component.exports